import { DEFAULT_CURRENCY_PLACEHOLDER } from '../../../../../../constants';
import { getGridFormattedFloat } from '../../../../../../utils/getGridFormattedFloat';
import { formatString } from '../../../../../../utils/formatString';
import { formatFloat } from '../../../../../../utils/formatFloat';

export const formatStaticNumberValue = (
  value: number | null | undefined,
  isFloat: boolean,
  resolvedFormat: string | undefined,
  defaultCurrencyFormat: string | null | undefined
): string => {
  if (value === null || value === undefined) return '';

  if (resolvedFormat) {
    // replace %m placeholder with the user's currency format before sprintf
    const withCurrency = defaultCurrencyFormat
      ? resolvedFormat.replaceAll(
          DEFAULT_CURRENCY_PLACEHOLDER,
          defaultCurrencyFormat
        )
      : resolvedFormat;
    // step 1: sprintf template → e.g. "1234.56 Kč"
    const sprintfResult = formatString(withCurrency, value);
    // step 2: reformat numeric part with Czech locale → e.g. "1 234,56 Kč"
    return isFloat
      ? getGridFormattedFloat(sprintfResult, { format: withCurrency })
      : String(sprintfResult);
  }

  // no format template — direct locale formatting
  return isFloat ? formatFloat(value) : String(value);
};
